import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import VueLib from 'vue';
import * as Sentry from '@sentry/browser';
import { Dedupe, ExtraErrorData, ReportingObserver, RewriteFrames, Vue } from '@sentry/integrations';
export default function (ctx, inject) {
  const opts = Object.assign({}, {
    "dsn": "https:\u002F\u002F26e7e907eb0447b38776ba0a51b77384:f700063f3f524847844ec0f715313228@sentry.io\u002F294125",
    "environment": "production",
    "whitelistUrls": [/www\.maisonsdumonde\.com/, /cdn\.maisonsdumonde\.com/]
  }, {
    integrations: [new Dedupe({}), new ExtraErrorData({}), new ReportingObserver({}), new RewriteFrames({}), new Vue(_objectSpread({
      Vue: VueLib
    }, {
      "attachProps": true
    }))]
  }); // Initialize sentry

  Sentry.init(opts); // Inject Sentry to the context as $sentry

  inject('sentry', Sentry);
}